import React from "react";
import { GetPricesOfCurrency } from "./Hit";
import ProductSlider from "../../../Components/ProductSlider";
import { GetProductGtm } from "../utils/ProductGtm";
import { RecommendViewProps } from "./types/RecommendViewProps";
import { HitImages, HitUrl } from "../utils/HitUtils";

function RecommendedSliderView(props: RecommendViewProps) {
  const products = props.items.map((hit) => {
    const url = HitUrl(hit);
    const priceGroup = GetPricesOfCurrency(hit.price);
    const imageUrls = HitImages(hit);
    return {
      name: hit.styleName || hit.name,
      brand: hit.brand,
      decsription: hit.description,
      url: url,
      price: priceGroup.formattedPrice,
      campaignPrice: priceGroup.formattedCampaignPrice,
      discountPercent: priceGroup.formattedDiscountInPercentage,
      image1: imageUrls.length > 0 ? imageUrls[0] : "",
      image2: imageUrls.length > 1 ? imageUrls[1] : "",
      articleNumber: hit.objectID,
      show: [
        "quick-add",
        "brand",
        "name",
        "price",
        "wish-list",
        "tags",
        "color-picker",
        "voucher-code",
      ],
      gtmProduct: GetProductGtm(
        hit,
        priceGroup.actualPrice,
        priceGroup.discount
      ),
      inStock: hit.inStock,
      variants: hit.variants,
    };
  });
  return <ProductSlider {...{ products, slidesPerView: props.slidesPerView, showBuyButton: props.showBuyButton }}></ProductSlider>;
}

function RecommendedGridView(props: RecommendViewProps) {
  return (
    <div className="algolia-recommend-products" data-algolia-recommend-products>
      <div className="related-products__list row">
        {props.items.map((item) => (
          <props.itemComponent item={item} key={item.objectID} />
        ))}
      </div>
    </div>
  );
}

export function RecommendView(props: RecommendViewProps) {
  const sliderLimit = 4;

  return props.items.length > sliderLimit ? (
    <RecommendedSliderView {...props} />
  ) : (
    <RecommendedGridView {...props} />
  );
}
